import React from 'react';
import { dateFormatter } from '../../../../../../helpers';
import { 
    StyledArticleSummaryContainer,
    StyledArticleCategory,
    StyledSlash,
    StyledArticleCreationDate,
    StyledArticleReadTime
} from "./styled";

const ArticleSummary = ({ category: { name }, date, read_time }) => {
    const creationDate = dateFormatter(date);
    return (
        <StyledArticleSummaryContainer>
        <StyledArticleCategory>{name}</StyledArticleCategory>
        <StyledSlash>/</StyledSlash>
        <StyledArticleCreationDate>{creationDate}</StyledArticleCreationDate>
        <StyledSlash>/</StyledSlash>
        <StyledArticleReadTime>{read_time}</StyledArticleReadTime>
      </StyledArticleSummaryContainer>
    );
}

export default ArticleSummary;
